import React from 'react';
import AdminAuth from '../components/admin/AdminAuth';
import BlogEditor from '../components/admin/BlogEditor';

const BlogEditorPage = () => {
  return (
    <AdminAuth>
      <BlogEditor />
    </AdminAuth>
  );
};

export default BlogEditorPage;